export default "__VITE_ASSET__Ch6b5f$i__"